import { IsoLocale } from "@izettle/constants"

import { AppProvider } from "@/core/components/app-provider"
import { Error404 } from "@/core/components/error-404"
import MembersPolicyPage from "@/modules/members/pages/integrity_policy"
import MembersOptInPage from "@/modules/members/pages/optin"
import { DigitalReceiptsOptOut } from "@/modules/opt-out/pages/digital-receipts-opt-out"
import { DigitalReceiptsOptOutStatus } from "@/modules/opt-out/pages/digital-receipts-opt-status"
import { SignUpPage } from "@/modules/sign-up/pages/landing"
import { OptOutFromSellerPage } from "@/modules/sign-up/pages/optout-from-seller"
import { SellerPrivacyPage } from "@/modules/sign-up/pages/seller-privacy-page"

type AppRoute = {
  path: string
  element: JSX.Element
}

const receiptAllowedLocales = [
  IsoLocale.daDK,
  IsoLocale.deDE,
  IsoLocale.enGB,
  IsoLocale.esES,
  IsoLocale.esMX,
  IsoLocale.fiFI,
  IsoLocale.frFR,
  IsoLocale.itIT,
  IsoLocale.nbNO,
  IsoLocale.nlNL,
  IsoLocale.ptBR,
  IsoLocale.svFI,
  IsoLocale.svSE,
]

const customerAllowedLocales = [IsoLocale.enGB, IsoLocale.enUS, IsoLocale.esUS]

const customerLegacyAllowedLocales = [
  IsoLocale.enGB,
  IsoLocale.daDK,
  IsoLocale.deDE,
  IsoLocale.esES,
  IsoLocale.frFR,
  IsoLocale.itIT,
  IsoLocale.nbNO,
  IsoLocale.nlNL,
  IsoLocale.fiFI,
  IsoLocale.svSE,
]

export const appRoutes: AppRoute[] = [
  {
    path: "/receipt/:id/opt-out",
    element: (
      <AppProvider allowedLocales={receiptAllowedLocales} defaultLocale={IsoLocale.enGB}>
        <DigitalReceiptsOptOut />
      </AppProvider>
    ),
  },
  {
    path: "/receipt/:id/opt-status",
    element: (
      <AppProvider allowedLocales={receiptAllowedLocales} defaultLocale={IsoLocale.enGB}>
        <DigitalReceiptsOptOutStatus />
      </AppProvider>
    ),
  },
  {
    path: "/sign-up/:orgUuid/receipt/:purchaseUuid",
    element: (
      <AppProvider allowedLocales={customerAllowedLocales} defaultLocale={IsoLocale.enUS}>
        <SignUpPage />
      </AppProvider>
    ),
  },
  {
    path: "/privacy/:orgUuid",
    element: (
      <AppProvider allowedLocales={customerAllowedLocales} defaultLocale={IsoLocale.enUS}>
        <SellerPrivacyPage />
      </AppProvider>
    ),
  },
  {
    path: "/seller/:orgUuid/optout/:customerUuid",
    element: (
      <AppProvider allowedLocales={customerAllowedLocales} defaultLocale={IsoLocale.enUS}>
        <OptOutFromSellerPage />
      </AppProvider>
    ),
  },
  {
    path: "/members/:memberUuid/optin",
    element: (
      <AppProvider
        allowedLocales={customerLegacyAllowedLocales}
        defaultLocale={IsoLocale.enGB}
      >
        <MembersOptInPage />
      </AppProvider>
    ),
  },
  {
    path: "/members/:memberUuid/integrity_policy",
    element: (
      <AppProvider
        allowedLocales={customerLegacyAllowedLocales}
        defaultLocale={IsoLocale.enGB}
      >
        <MembersPolicyPage />
      </AppProvider>
    ),
  },
  {
    path: "*",
    element: (
      <AppProvider>
        <Error404 />
      </AppProvider>
    ),
  },
]
